import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Popover } from 'primeng/popover';

export interface GuiasRejeitadasFilterData {
  motivo_guia: string[];
  motivo_item: string[];
}

@Component({
    selector: 'bl-guias-rejeitadas-filtro',
    templateUrl: './filtro.component.html',
    styleUrls: ['./filtro.component.scss'],
    standalone: false
})
export class GuiasRejeitadasFiltroComponent implements OnChanges {
  @ViewChild('filterPanel') filterPanel: Popover;

  @Input() data: GuiasRejeitadasFilterData;
  @Input() motivoGuiaOptions: SelectItem<string>[] = [];
  @Input() motivoItemOptions: SelectItem<string>[] = [];

  @Output() dataChange = new EventEmitter<GuiasRejeitadasFilterData>();
  @Output() onChange = new EventEmitter<GuiasRejeitadasFilterData>();

  count = 0;
  label = '';

  localMotivoGuia: string[] = [];
  localMotivoItem: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.updateLabel();
    }
  }

  private updateLabel() {
    this.count = (this.data?.motivo_guia?.length ?? 0) + (this.data?.motivo_item?.length ?? 0);
    this.label = this.count === 0 ? '' : this.count + ' filtro' + (this.count > 1 ? 's' : '');
  }

  onShow($event: Event) {
    this.localMotivoGuia = [...(this.data?.motivo_guia ?? [])];
    this.localMotivoItem = [...(this.data?.motivo_item ?? [])];
    this.filterPanel.toggle($event);
  }

  onApply() {
    this.data = {
      motivo_guia: this.localMotivoGuia,
      motivo_item: this.localMotivoItem,
    };
    this.updateLabel();
    this.dataChange.emit(this.data);
    this.onChange.emit(this.data);
    this.filterPanel.hide();
  }

  onClear() {
    this.localMotivoGuia = [];
    this.localMotivoItem = [];
    this.data = { motivo_guia: [], motivo_item: [] };
    this.count = 0;
    this.label = '';
    this.dataChange.emit(this.data);
    this.onChange.emit(this.data);
    this.filterPanel.hide();
  }
}
